import {
  FolderAssetType,
} from '@bingads-webui-campaign-react/asset-library-model';

import { transformImageResponse } from './image-response-transformer';
import { transformVideoResponse } from './video-response-transformer';

export const getAssetTransformer = (folderAssetType) => {
  if (folderAssetType === FolderAssetType.Video) {
    return transformVideoResponse;
  }

  if (folderAssetType === FolderAssetType.Image) {
    return transformImageResponse;
  }

  if (folderAssetType) {
    throw new Error(`No transfomers configed for FolderAssetType - ${folderAssetType}`);
  }

  return transformImageResponse;
};

export const transformAssetResponse = (asset, folderAssetType, i18n) => {
  const transformerFunc = getAssetTransformer(folderAssetType);

  return transformerFunc(asset, i18n);
};
